import { API } from "@/lib/api";

let crestPromise = null;

const norm = (s) => (s || "").trim().toLowerCase();

export const getCrestMap = () => {
  if (!crestPromise) {
    crestPromise = Promise.all([
      API.get("/sporting/match").then(({ data }) => data.crest || null).catch(() => null),
      API.get("/crests").then(({ data }) => data.crests || []).catch(() => []),
    ]).then(([sporting, list]) => {
      const map = {};
      list.forEach((c) => {
        if (c.name && c.url) map[norm(c.name)] = c.url;
      });
      if (sporting && !map["sporting de gijón"]) map["sporting de gijón"] = sporting;
      return map;
    });
  }
  return crestPromise;
};

export const getCrest = () => getCrestMap().then((m) => m["sporting de gijón"] || null);

export const findCrest = (map, teamName) => map[norm(teamName)] || null;
